var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticStyle:{"position":"absolute","top":"-25px","left":"10px","background-color":"transparent"},attrs:{"to":"/"}},[_c('logo')],1),_c(_vm.$route.params.page,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }